import { gql } from "@apollo/client";

export const GET_ORG_ANALYSIS = gql`
  query GetOrgAnalytics($orgId: String) {
    getOrgAnalytics(orgId: $orgId) {
      id
      orgId
      numberOfViews
      numberOfSaves
      numberOfRefers
      numberOfSuggestEdits
      savedBy {
        id
        firstName
        lastName
        avatarUrl
        email
        verified
        plan
        state
        country
        gender
        employmentStatus
        incomeLevel
        insurance
        phone
        dob
      }
      referBy {
        id
        firstName
        lastName
        avatarUrl
        email
        verified
        plan
        state
        country
        gender
        employmentStatus
        incomeLevel
        insurance
        phone
        dob
      }
      suggestEditsBy
      viewsDates
      saveDates
      referDates
      suggestEditsDates
    }
  }
`;
